import React from "react";

const DocumentSkeleton = ({ count = 8 }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4'>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className='border border-gray-200 rounded-lg bg-white shadow-md animate-pulse'
        >
          <div className='p-6 space-y-4'>
            <div className='flex justify-between items-start'>
              <div className='flex items-center gap-2 flex-1'>
                <div className='h-11 w-9 bg-gray-200 rounded'></div>
                <div className='flex-1 space-y-2'>
                  <div className='h-4 bg-gray-200 rounded w-3/4'></div>
                  <div className='h-3 bg-gray-200 rounded w-1/2'></div>
                </div>
              </div>
              <div className='h-6 w-6 bg-gray-200 rounded'></div>
            </div>
            <div className='space-y-2'>
              <div className='h-3 bg-gray-200 rounded w-full'></div>
              <div className='flex justify-between items-center'>
                <div className='h-3 bg-gray-200 rounded w-1/3'></div>
                <div className='h-4 w-4 bg-gray-200 rounded'></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocumentSkeleton;

